import { SectionShell } from "@/components/design-system/SectionShell";
import { Stat } from "@/components/ui/stat";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@/components/ui/table";
import { TrendChart } from "@/components/charts/TrendChart";
import { Funnel } from "@/components/charts/Funnel";

const SAMPLE_TREND = [
  { date: "2026-07-01", views: 8, uniques: 6 },
  { date: "2026-07-02", views: 14, uniques: 10 },
  { date: "2026-07-03", views: 9, uniques: 7 },
  { date: "2026-07-04", views: 22, uniques: 15 },
  { date: "2026-07-05", views: 18, uniques: 13 },
  { date: "2026-07-06", views: 27, uniques: 19 },
  { date: "2026-07-07", views: 31, uniques: 21 },
];

const SAMPLE_FUNNEL = [
  { key: "visitors", label: "Visitors", count: 100, pct_of_top: 100, pct_of_prev: null },
  { key: "reached", label: "Reached form", count: 46, pct_of_top: 46, pct_of_prev: 46 },
  { key: "started", label: "Started form", count: 22, pct_of_top: 22, pct_of_prev: 47.8 },
  { key: "submitted", label: "Submitted form", count: 9, pct_of_top: 9, pct_of_prev: 40.9 },
];

export function DataVizSection() {
  return (
    <SectionShell
      id="data-viz"
      title="Data & charts"
      description="Lightweight, dependency-free primitives for the admin dashboard: a KPI stat tile, a columnar table, and two inline-SVG charts. Chart series colors come from the dataviz-validated --color-chart-* tokens; the funnel uses the accent."
      whenToUse={
        <ul>
          <li>KPI rows, analytics tables, and trend / funnel visualizations.</li>
          <li>Any dense, multi-column data that a key/value DataTable can't hold.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Key/value record details — use the DataTable (&lt;dl&gt;) instead.</li>
          <li>More than two simultaneous chart series — the validated palette covers a two-series pair.</li>
        </ul>
      }
      preview={
        <div className="space-y-8">
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            <Stat label="Views" value="1,204" />
            <Stat label="Unique visitors" value="812" />
            <Stat label="Leads" value="26" />
            <Stat label="Conversion" value="3.2%" sub="leads / unique visitor" />
          </div>

          <TrendChart data={SAMPLE_TREND} />

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <Funnel steps={SAMPLE_FUNNEL} />
            <div className="overflow-hidden rounded-lg border border-hairline bg-page">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeaderCell>Source</TableHeaderCell>
                    <TableHeaderCell className="text-right">Views</TableHeaderCell>
                    <TableHeaderCell className="text-right">Conv.</TableHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell className="font-medium text-ink-display">linkedin</TableCell>
                    <TableCell className="text-right tabular-nums">312</TableCell>
                    <TableCell className="text-right tabular-nums">4.5%</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className="font-medium text-ink-display">Direct</TableCell>
                    <TableCell className="text-right tabular-nums">201</TableCell>
                    <TableCell className="text-right tabular-nums">2.0%</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
      }
      code={`import { Stat } from "@/components/ui/stat"
import { Table, TableHead, TableBody, TableRow, TableHeaderCell, TableCell } from "@/components/ui/table"
import { TrendChart } from "@/components/charts/TrendChart"
import { Funnel } from "@/components/charts/Funnel"

<Stat label="Views" value="1,204" />

<TrendChart data={[{ date: "2026-07-01", views: 8, uniques: 6 }, /* ... */]} />

<Funnel steps={[{ key: "visitors", label: "Visitors", count: 100, pct_of_top: 100, pct_of_prev: null }, /* ... */]} />

<Table>
  <TableHead><TableRow><TableHeaderCell>Source</TableHeaderCell></TableRow></TableHead>
  <TableBody><TableRow><TableCell>linkedin</TableCell></TableRow></TableBody>
</Table>`}
    />
  );
}
